/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconColorProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconColor from './useIconColor';

/*
 * Defines the Design Language System (DLS) Side Nav Dashboard Icon component.
 *
 * ! NOTE: This Icon defines non-standard sizes within the DLS.
 *   https://www.figma.com/file/gtF4hB3eC4fvzKVJ2DNDtu/00_DLS_Foundation?node-id=1%3A172
 */
export const SideNavDashboardIcon = ({color}: IconColorProps) => {
  const iconColor = useIconColor(color);
  return (
    <ThemeIconProvider name='SideNavDashboardIcon' color={color} legacyIcon={(
      <svg width={23} height={21} viewBox='0 0 23 21' fill='none'>
        <rect x={1}
          y={1}
          width={8.421}
          height={9.429}
          rx={0.5}
          stroke={iconColor}
          strokeWidth={1.5} />
        <rect x={12.579}
          y={9.572}
          width={8.421}
          height={9.429}
          rx={0.5}
          stroke={iconColor}
          strokeWidth={1.5} />
        <rect x={12.579}
          y={1}
          width={8.421}
          height={6}
          rx={0.5}
          stroke={iconColor}
          strokeWidth={1.5} />
        <rect x={1}
          y={13}
          width={8.421}
          height={6}
          rx={0.5}
          stroke={iconColor}
          strokeWidth={1.5} />
      </svg>
    )} />
  );
};
